<div class="app__container mt-10 flex flex-col gap-6">
	<activar-back-button text="Volver" class="mt-5" [routerLink]="['/usuarios']" />

	@if (user(); as user) {
	<div class="flex flex-col justify-between md:flex-row md:items-center">
		<h2 class="flex text-left text-primary-900 w-full">
			{{ user.firstName }} {{ user.lastName }} {{ user.companyName }}
		</h2>
		<div class="flex gap-2">
			@if (canManageStatus()) {
				@if(isActive()){
					<activar-button fill="out" color="danger" text="Desactivar" (click)="handleUserStatus()"/>
				}@else{
					<activar-button fill="out" color="success" text="Activar" (click)="handleUserStatus()"/>
				}
				@if (!isBlocked()) {
					<activar-button fill="out" color="danger" text="Bloquear" (click)="handleBlockUser()"/>
				}
			}
			
			
			@if (isProspect()) {
			<activar-button fill="solid" color="primary" class="flex-1" (click)="handleProspectEditClick()">
				<div class="flex flex-row justify-center items-center w-full gap-2">
					<activar-icon name="edit" size="15px"> </activar-icon>
					<p>Modificar</p>
				</div>
			</activar-button>
			<activar-button fill="solid" color="danger" class="flex-1" (click)="handleProspectDeleteClick()">
				<div class="flex flex-row justify-center items-center w-full gap-2">
					<activar-icon name="x_circle" size="15px"> </activar-icon>
					<p>Eliminar</p>
				</div>
			</activar-button>
			} @else {
			@if (isClientTarget()) {
			<activar-button fill="out" color="primary" class="whitespace-nowrap" *showForRole="['ADMIN', 'SUPERADMIN']" (click)="handleAgentReassignClick()">
				<div class="flex flex-row justify-center items-center gap-2">
					<activar-icon name="user_edit" size="15px"> </activar-icon>
					<p>Modificar PAS</p>
				</div>
			</activar-button>
			}
			<activar-button fill="solid" color="primary" class="" (click)="handleUserEditClick()">
				<div class="flex flex-row justify-between items-center w-full gap-2">
					<activar-icon name="edit" size="15px"> </activar-icon>
					<p>Modificar</p>
				</div>
			</activar-button>
			}
		</div>
	</div>

	<div class="flex flex-row gap-6">
		<activar-tabs [tabs]="tabs()" [vertical]="true" (switch)="setCurrentTab($event)"
			*showForRole="['PROSPECT', 'CLIENT']" />

		<div class="w-full">
			@if (currentTab(); as tab) {
			@if (tab === tabNames.Info) {
			<app-user-info [user]="user" />
			} @else if (tab === tabNames.Quotes) {
			<app-user-quotes [isProspect]="isProspect()" class="w-full" />
			} @else if (tab === tabNames.Policies) {
			<app-user-policies class="w-full" />
			} @else if (tab === tabNames.PaymentMethods) {
			<app-user-payments [user]="user" />
			}
			}
		</div>
	</div>
	}

	<activar-modal [(visible)]="showDeleteConfirmModal">
		<div class="flex-col mx-auto p-5 text-center" style="width: 400px">
			<h2>¿Eliminar prospecto?</h2>
			<p>Esta acción no se puede deshacer y borrará todas las cotizaciones asociadas.</p>

			<div class="flex mt-7 items-center justify-center gap-5">
				<activar-button text="Cancelar" fill="out" expand="full" color="primary" (click)="closeDeleteModal()" />
				<activar-button text="Eliminar" fill="solid" expand="full" color="danger" (click)="confirmDelete()" />
			</div>
		</div>
	</activar-modal>
	<activar-modal [(visible)]="showStatusModal">
		<div class="flex-col mx-auto p-5 text-center">
			<h2>¿{{getStatusText()}} usuario?</h2>

			<div class="flex mt-7 items-center justify-center gap-5">
				<activar-button text="Cancelar" fill="out" expand="full" color="primary" (click)="closeStatusModal()" />
				<activar-button [text]="getStatusText()" fill="solid" expand="full" color="primary" (click)="confirmStatusChange()" />
			</div>
		</div>
	</activar-modal>
	<activar-modal [(visible)]="showBlockModal">
		<div class="flex-col mx-auto p-5 text-center" style="width: 400px">
			<h2>¿Bloquear usuario?</h2>
			<p>El usuario no podrá ingresar a la plataforma hasta que sea activado nuevamente.</p>

			<div class="flex mt-7 items-center justify-center gap-5">
				<activar-button text="Cancelar" fill="out" expand="full" color="primary" (click)="closeBlockModal()" />
				<activar-button text="Bloquear" fill="solid" expand="full" color="danger" (click)="confirmBlock()" />
			</div>
		</div>
	</activar-modal>
</div>